export default [
    {
      path: '/offer',
      component: () => import('./views/Index'),
      name: 'offer',
      redirect: { name: 'offer-list' },
      children: [
        {
          path: '',
          name: 'offer-list',
          component: () => import('./views/List'),
          meta: {
            resource: 'auth',
          },
        },
        {
          path: ':id',
          name: 'offer-detail',
          component: () => import('./views/Detail'),
          meta: {
            resource: 'auth',
          },
        },
      ],
    },
  ]
  